// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js!../../../node_modules/@material/checkbox/dist/mdc.checkbox.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mdc-checkbox {
    --mdc-theme-secondary: #1976d2;
}
`, "",{"version":3,"sources":["webpack://./src/shared/css/material-checkbox.css"],"names":[],"mappings":"AAEA;IACI,8BAA8B;AAClC","sourcesContent":["@import '../../../node_modules/@material/checkbox/dist/mdc.checkbox.css';\n\n.mdc-checkbox {\n    --mdc-theme-secondary: #1976d2;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
